import React from "react";
import { ErrorText, PortalIconActionButton, PortalIconActionButtonGlyph } from "src/components";

const VisibilitySection = ({
    togglePollVisibilityModal,
    pollVisibilityError,
    label,
    buttonWidth,
    buttonHeight,
    showButton
}) => {
    return (
        <>
            { showButton &&
                <PortalIconActionButton
                    type="button"
                    onClick={() => togglePollVisibilityModal()} 
                    width={buttonWidth}
                    height={buttonHeight ?? "42px"}
                    minWidth="0"
                >
                    <PortalIconActionButtonGlyph width="18px" height="18px">+</PortalIconActionButtonGlyph>
                    { label }
                </PortalIconActionButton>
            }
            { pollVisibilityError.length > 0 && <ErrorText>{pollVisibilityError}</ErrorText> }
        </>
    );
};

export default VisibilitySection;
